import PropTypes from 'prop-types';
import React from 'react';
import {
  TranslationProvider,
} from '@resy/ui-kitchen';

import ConfirmCancel from '../ConfirmCancel';

const renderCancellationPolicy = (policy) => (
  <div className="cancellation_policy_text">
    <p>{policy[0]}</p>
  </div>
);

const Cancel = ({
  cancelClick,
  cancelCtaKey,
  cancelCtaText,
  confirmClick,
  confirmCtaKey,
  confirmCtaText,
  reservation,
}) => (
  <ConfirmCancel
    cancelClick={cancelClick}
    cancelCtaKey={cancelCtaKey}
    cancelCtaText={cancelCtaText}
    confirmClick={confirmClick}
    confirmCtaKey={confirmCtaKey}
    confirmCtaText={confirmCtaText}
  >
    <TranslationProvider translationKey="cancel_reservation_header">
      <h2>Cancel Reservation</h2>
    </TranslationProvider>
    {(reservation.cancellationPolicy?.length > 0) && renderCancellationPolicy(reservation.cancellationPolicy)}
  </ConfirmCancel>
);

export default Cancel;

Cancel.propTypes = {
  cancelClick: PropTypes.func,
  cancelCtaKey: PropTypes.string,
  cancelCtaText: PropTypes.string,
  confirmClick: PropTypes.func,
  confirmCtaKey: PropTypes.string,
  confirmCtaText: PropTypes.string,
  reservation: PropTypes.shape({
    cancellation: PropTypes.shape({
      fee: PropTypes.shape({
        amount: PropTypes.number,
        display: PropTypes.shape({
          amount: PropTypes.string,
        }),
      }),
    }),
    cancellationPolicy: PropTypes.arrayOf(PropTypes.string),
    date_refund_cut_off: PropTypes.string,
    date_credit_cut_off: PropTypes.string,
    fee: PropTypes.shape({
      date_cut_off: PropTypes.string,
    }),
    price: PropTypes.number,
    venue: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

Cancel.defaultProps = {
  cancelClick: undefined,
  cancelCtaKey: undefined,
  cancelCtaText: undefined,
  confirmClick: undefined,
  confirmCtaKey: undefined,
  confirmCtaText: undefined,
  reservation: undefined,
};
